/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Datatype1Inputs */

const en_entity_datatype1 = /** @type {(inputs: Entity_Datatype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Type`)
};

const de_entity_datatype1 = /** @type {(inputs: Entity_Datatype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datentyp`)
};

/**
* | output |
* | --- |
* | "Data Type" |
*
* @param {Entity_Datatype1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_datatype1 = /** @type {((inputs?: Entity_Datatype1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Datatype1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_datatype1(inputs)
	return de_entity_datatype1(inputs)
});
export { entity_datatype1 as "entity_dataType" }